<template>
  <div class="pt-15">
    <MattrzBaseLogo width="350" />
    <div class="pa-4 mx-auto my-5" style="width: 400px;">
      <AcceptInvitationContainer />
    </div>
  </div>
</template>
<script>
import AcceptInvitationContainer from '/src/container/pages/AcceptInvitationContainer'
import MattrzBaseLogo from '/src/components/uiParts/images/MattrzBaseLogo'

export default {
  name: 'AcceptInvitation',
  components: {
    AcceptInvitationContainer,
    MattrzBaseLogo
  },
  methods: {
  }
}
</script>
